import { useLocation, useNavigate } from "react-router-dom";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import AccountNumberWithBank from "../../_utils/CommonViewAllCard/CardSubComponent/AccountNumberWithBank";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { useSelector } from "react-redux";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import CardActionableButton from "../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";
import TickerAnimation from "../../_utils/TickerAnimation";
import { IntervalConfiguration } from "../../../utils/configurationProvider";

const InternalTxnViewAllCard = ({
  setLoading,
  setOpenTransHistory,
  data,
  isSidebarOpen,
  isDistributionPopoverOpen,
  isPopoverOpen,
  currentStatus,
  txnHistorytype,
  onClose,
  paginationDivHeight,
  isLabelClicked,
  setLabelAccounts,
  setLabeldata,
  LabelAccounts,
  Labeldata,
  setlableInput,
  filterRef,
  openTransHistory,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const services = useSelector((state) => state.refreshToken.services);
  const benealldata = data;

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "hold":
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };

  const getDistriStatusColor = (status) => {
    switch (status) {
      case "awaiting_verification":
      case "awaiting_funds":
      case "distribution_initiated":
      case "created":
      case "distribution_pending":
      case "approved":
        return "var(--queued)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "distribution_complete":
        return "var(--settled)";
      default:
        return "var(--text-primary)";
    }
  };

  return (
    <div
      className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md ${
        isSidebarOpen ? "sidebar-open" : ""
      }`}
    >
      {benealldata?.map((transactions, index) => {
        return (
          <>
            <CardContainer
              filterRef={filterRef}
              hoverHeight={GlobalConfiguration?.internalTxnCardHoverHeight}
              context={transactions}
              isSelected={
                Array.isArray(LabelAccounts) &&
                LabelAccounts.includes(transactions?.txn_id)
              }
              onClickHandler={() => {
                const options =
                  transactions?.lifecycle_status === "pending" &&
                  services?.includes("AInternalTxn")
                    ? {
                        state:
                          currentStatus === "require approval"
                            ? "require approval"
                            : transactions?.lifecycle_status,
                      }
                    : {};

                if (txnHistorytype === "internalTxnHistory") {
                  setOpenTransHistory(false);
                  setLoading(true);

                  setTimeout(() => {
                    setLoading(false);
                  }, IntervalConfiguration.intervalExtraLarge);

                  if (isLabelClicked) {
                    if (LabelAccounts.includes(transactions?.txn_id)) {
                      setLabelAccounts(
                        LabelAccounts.filter(
                          (id) => id !== transactions?.txn_id,
                        ),
                      );
                    } else {
                      setLabelAccounts([
                        ...LabelAccounts,
                        transactions?.txn_id,
                      ]);
                      setLabeldata([...Labeldata, transactions]);
                    }
                    setlableInput(false);
                  } else {
                    onClose?.call();
                    navigate(
                      `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${transactions?.txn_id}`,
                      {
                        replace: openTransHistory ? true : false,
                      },
                      {
                        state: {
                          isViewAll:
                            location.pathname ===
                            "/internal_transaction_dashboard/internal_transaction_view_all"
                              ? true
                              : false,
                        },
                      },
                    );
                    if (openTransHistory) {
                      onClose();
                    }
                  }
                } else if (
                  !isSidebarOpen &&
                  !isPopoverOpen &&
                  !isDistributionPopoverOpen
                ) {
                  if (isLabelClicked) {
                    if (LabelAccounts.includes(transactions?.txn_id)) {
                      setLabelAccounts(
                        LabelAccounts.filter(
                          (id) => id !== transactions?.txn_id,
                        ),
                      );
                    } else {
                      setLabelAccounts([
                        ...LabelAccounts,
                        transactions?.txn_id,
                      ]);
                      setLabeldata([...Labeldata, transactions]);
                    }
                    setlableInput(false);
                  } else {
                    navigate(
                      `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${transactions?.txn_id}`,
                      {
                        state: {
                          isViewAll:
                            location.pathname ===
                            "/internal_transaction_dashboard/internal_transaction_view_all"
                              ? true
                              : false,
                          options: options,
                        },
                      },
                    );
                  }
                } else {
                  onClose?.call();

                  navigate(
                    `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${transactions?.txn_id}`,
                    {
                      state: {
                        isViewAll:
                          location.pathname ===
                          "/internal_transaction_dashboard/internal_transaction_view_all"
                            ? true
                            : false,
                      },
                    },
                  );
                }
              }}
            >
              <card-body>
                <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                  <div className="w-full flex justify-between items-center">
                    <p
                      className="text-font-sm flex-1 truncate font-semibold"
                      style={{
                        color: "var(--settled)",
                      }}
                    >
                      {!shouldBeRedacted(transactions?.amount) && "INR"}{" "}
                      <FormatAmount
                        price={Number(
                          String(transactions?.amount)?.replaceAll(",", ""),
                        )}
                      />
                    </p>

                    <div
                      className="gap-x-gap-sm ml-margin-sm justify-end"
                      style={{
                        display:
                          transactions?.confidential_transaction === "Y" ||
                          isLabelClicked
                            ? "flex"
                            : "none",
                      }}
                    >
                      {transactions?.confidential_transaction === "Y" && (
                        <CardActionableButton
                          icon="https://q2pay.in/new_assets/common/detail_page/confidential_transaction.svg"
                          title="confidential"
                          isDisabled={false}
                        />
                      )}

                      {isLabelClicked && (
                        <CardActionableButton
                          icon={
                            Array.isArray(LabelAccounts) &&
                            LabelAccounts.includes(transactions?.txn_id)
                              ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                              : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                          }
                          isDisabled={false}
                        />
                      )}
                    </div>
                  </div>

                  <p className="text-font-xs transform-none text-text-secondary">
                    Amount
                  </p>
                </div>
                <AccountNumberWithBank
                  sourceAccNo={transactions?.owner_account_bank_acc_no}
                  destinationAccNo={transactions?.internal_account_bank_acc_no}
                  destinationIfsc={transactions?.internal_account_ifsc_code}
                  sourceIfsc={transactions?.owner_account_ifsc_code}
                />
                <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                  <div className="w-full flex justify-between items-center">
                    <p
                      className="text-font-sm flex-1 truncate font-normal"
                      style={{
                        textTransform: "capitalize",
                        color: "var(--text-primary)",
                      }}
                    >
                      <TickerAnimation
                        text={
                          transactions?.created_on
                            ? formatDateViewAll(
                                transactions?.created_on,
                                false,
                                false,
                              )
                            : "Not given"
                        }
                      />
                    </p>
                  </div>

                  <p className="text-font-xs transform-none text-text-secondary">
                    Created on
                  </p>
                </div>
              </card-body>
              <card-hover>
                <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                  <div className="w-full flex justify-between items-center">
                    <p
                      className="text-font-sm flex-1 truncate font-semibold"
                      style={{
                        textTransform: "capitalize",
                        color:
                          transactions?.lifecycle_status === "N/A"
                            ? "var(--text-primary)"
                            : getStatusColor(transactions?.lifecycle_status),
                      }}
                    >
                      <TickerAnimation
                        text={
                          currentStatus === "require approval"
                            ? "Require approval"
                            : transactions?.lifecycle_status || "N/A"
                        }
                      />
                    </p>
                  </div>

                  <p className="text-font-xs transform-none text-text-secondary">
                    Approval status
                  </p>
                </div>
                <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                  <div className="w-full flex justify-between items-center">
                    <p
                      className="text-font-sm flex-1 truncate font-semibold"
                      style={{
                        color:
                          transactions?.distribution_lifecycle_status === "N/A"
                            ? "var(--text-primary)"
                            : getDistriStatusColor(
                                transactions?.distribution_lifecycle_status,
                              ),
                      }}
                    >
                      <TickerAnimation
                        text={
                          transactions?.distribution_lifecycle_status ===
                          "created"
                            ? "Distribution created"
                            : transactions?.distribution_lifecycle_status ===
                                "awaiting_funds"
                              ? "Awaiting funds"
                              : transactions?.distribution_lifecycle_status ===
                                  "distribution_initiated"
                                ? "Distribution initiated"
                                : transactions?.distribution_lifecycle_status ===
                                    "abandoned"
                                  ? "Distribution abandoned"
                                  : transactions?.distribution_lifecycle_status ===
                                      "rejected"
                                    ? "Distribution rejected"
                                    : transactions?.distribution_lifecycle_status ===
                                        "failed"
                                      ? "Distribution failed"
                                      : transactions?.distribution_lifecycle_status ===
                                          "distribution_complete"
                                        ? "Distribution complete"
                                        : transactions?.distribution_lifecycle_status ===
                                            "approved"
                                          ? "Distribution approved"
                                          : transactions?.distribution_lifecycle_status ||
                                            "N/A"
                        }
                      />
                    </p>
                  </div>

                  <p className="text-font-xs transform-none text-text-secondary">
                    Distribution status
                  </p>
                </div>

                <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                  <div className="w-full flex justify-between items-center">
                    <p
                      className="text-font-sm flex-1 truncate font-normal"
                      style={{
                        color: "var(--text-primary)",
                      }}
                    >
                      <TickerAnimation
                        text={
                          transactions?.labels?.join(", ") ||
                          "No labels assigned "
                        }
                      />
                    </p>

                    <div
                      className="gap-x-gap-sm ml-margin-sm justify-end"
                      style={{ display: "flex" }}
                    >
                      <CardActionableButton
                        icon="https://q2pay.in/new_assets/common/view_all/label.svg"
                        isDisabled={undefined}
                        title={undefined}
                      />
                    </div>
                  </div>
                </div>
              </card-hover>
            </CardContainer>
          </>
        );
      })}
    </div>
  );
};

export default InternalTxnViewAllCard;
